import { PropTypes } from 'prop-types';
var selectors = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);
var attemptHistory = PropTypes.arrayOf(PropTypes.shape({
  authoritative: PropTypes.bool.isRequired,
  displayName: PropTypes.string,
  percentage: PropTypes.number,
  pointsPossible: PropTypes.number,
  score: PropTypes.number,
  quizSessionId: PropTypes.string
}));
function numberInRange(start, end) {
  return function (props, propName, componentName, location) {
    var error = PropTypes.number.apply(null, arguments);
    if (error) return error;
    var value = props[propName];
    if (value != null && value < start || value > end) {
      return new Error("Invalid ".concat(location, " `").concat(propName, "` supplied to `").concat(componentName, "`, ") + "must be between ".concat(start, " and ").concat(end));
    }
  };
}
function higherOrderFunctionValidator(props, propName, componentName, location) {
  var propValue = props[propName];
  var propValueType = typeof propValue;
  if (propValueType !== 'function') {
    return new Error("Invalid ".concat(location, " `").concat(propName, "` of type `").concat(propValueType, "` ") + "supplied to `".concat(componentName, "`, expected a higher order function"));
  }
  var returnValue = propValue();
  var returnValueType = typeof returnValue;
  if (returnValueType !== 'function') {
    return new Error("Invalid ".concat(location, " `").concat(propName, "` supplied to `").concat(componentName, "`, ") + "the prop function returned a type of ".concat(returnValueType, ", expected a function"));
  }
}
export function requireable(func) {
  function required(isRequired, props, propName, componentName, location) {
    if (props[propName] != null) {
      return func(props, propName, componentName, location);
    }
    if (isRequired) {
      return new Error("Required ".concat(location, " `").concat(propName, "` was not supplied to ").concat(componentName));
    }
  }
  var requireableFunc = required.bind(null, false);
  requireableFunc.isRequired = required.bind(null, true);
  return requireableFunc;
}
var higherOrderFunction = requireable(higherOrderFunctionValidator);
function recordId(props, propName, componentName, location) {
  var error = PropTypes.string.apply(null, arguments);
  if (error) return error;
  if (!/^[1-9]\d*$/.test(props[propName])) {
    return new Error("Invalid ".concat(location, " `").concat(propName, "` supplied to `").concat(componentName, "`, must be a positive integer."));
  }
}
export var CustomPropTypes = {
  attemptHistory: attemptHistory,
  higherOrderFunction: higherOrderFunction,
  numberInRange: numberInRange,
  recordId: recordId,
  selectors: selectors
};
export default CustomPropTypes;